module.exports = __webpack_public_path__ + "static/media/AssociatesIconInactive.1efed8e2.png";